import { RESTClient, RESTClientMock } from './client';
import { fetchClinicalTrialAffiliateMock } from './mocks/clinicalTrialAffiliates';
import { API_URL } from './apiDictionary';
import { USE_API_MOCKS } from '../env';
import { UserRoles } from '@dynamika-shared/types/auth';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchClinicalTrialAffiliates = async (role: UserRoles) => {
  if (USE_API_MOCKS) {
    fetchClinicalTrialAffiliateMock();
  }

  try {
    return await api.get(API_URL.clinicalTrialsAffiliations, {
      params: { role },
    });
  } catch (error) {
    console.error('Error fetching subjects by site:', error);
    throw error;
  }
};
